export const WRONG_ADDRESS = {
    GET_ADDRESS: "GET_ADDRESS",
    GET_ADDRESS_SUCCESS: "GET_ADDRESS_SUCCESS",
    GET_ADDRESS_FAIL: "GET_ADDRESS_FAIL",

    ADDRESS_AUTOCORRECTION: "ADDRESS_AUTOCORRECTION",
    ADDRESS_AUTOCORRECTION_SUCCESS: "ADDRESS_AUTOCORRECTION_SUCCESS",
    ADDRESS_AUTOCORRECTION_FAIL: "ADDRESS_AUTOCORRECTION_FAIL",

    UPDATE_OR_CREATE_ADDRESS: "UPDATE_OR_CREATE_ADDRESS",
    UPDATE_OR_CREATE_ADDRESS_SUCCESS: "UPDATE_OR_CREATE_ADDRESS_SUCCESS",
    UPDATE_OR_CREATE_ADDRESS_FAIL: "UPDATE_OR_CREATE_ADDRESS_FAIL",

    GET_EXIST_ADDRESS_TYPES: "GET_EXIST_ADDRESS_TYPES",
    GET_EXIST_ADDRESS_TYPES_SUCCESS: "GET_EXIST_ADDRESS_TYPES_SUCCESS",
    GET_EXIST_ADDRESS_TYPES_FAIL: "GET_EXIST_ADDRESS_TYPES_FAIL",

    GET_SERVICE_WRONG_ADDRESS: "GET_SERVICE_WRONG_ADDRESS",
    GET_SERVICE_WRONG_ADDRESS_SUCCESS: "GET_SERVICE_WRONG_ADDRESS_SUCCESS",
    GET_SERVICE_WRONG_ADDRESS_FAIL: "GET_SERVICE_WRONG_ADDRESS_FAIL",

    BATCH_VERIFY_ADDRESSES: "BATCH_VERIFY_ADDRESSES",
    BATCH_VERIFY_ADDRESSES_SUCCESS: "BATCH_VERIFY_ADDRESSES_SUCCESS",
    BATCH_VERIFY_ADDRESSES_FAIL: "BATCH_VERIFY_ADDRESSES_FAIL",

    BATCH_GEO_WRONG_ADDRESS: "BATCH_GEO_WRONG_ADDRESS",
    BATCH_GEO_WRONG_ADDRESS_SUCCESS: "BATCH_GEO_WRONG_ADDRESS_SUCCESS",
    BATCH_GEO_WRONG_ADDRESS_FAIL: "BATCH_GEO_WRONG_ADDRESS_FAIL",

    BATCH_CORRECT_SERVICE_WRONG_ADDRESS: "BATCH_CORRECT_SERVICE_WRONG_ADDRESS",
    BATCH_CORRECT_SERVICE_WRONG_ADDRESS_SUCCESS: "BATCH_CORRECT_SERVICE_WRONG_ADDRESS_SUCCESS",
    BATCH_CORRECT_SERVICE_WRONG_ADDRESS_FAIL: "BATCH_CORRECT_SERVICE_WRONG_ADDRESS_FAIL",

    GET_DELIVERY_TYPES: "GET_DELIVERY_TYPES",
    GET_DELIVERY_TYPES_SUCCESS: "GET_DELIVERY_TYPES_SUCCESS",
    GET_DELIVERY_TYPES_FAIL: "GET_DELIVERY_TYPES_FAIL",

    GET_PROVINCES_COVERED: "GET_PROVINCES_COVERED",
    GET_PROVINCES_COVERED_SUCCESS: "GET_PROVINCES_COVERED_SUCCESS",
    GET_PROVINCES_COVERED_FAIL: "GET_PROVINCES_COVERED_FAIL"
}